<dtm-ui-loader-container *ngrxLet="isLoading$ as isLoading" [isShown]="isLoading">
    <div [ngClass]="{ hidden: isLoading }" class="lazy-content-container">
        <router-outlet></router-outlet>
    </div>
</dtm-ui-loader-container>
